import styled from 'styled-components'

import { breakpoint, mobile, zIndex } from 'app/theme/tokens'

export const ActionContainer = styled.div`
  display: flex;

  width: max-content;
  position: fixed;
  bottom: 0;
  right: -10px;
  z-index: ${zIndex.sticky + 1};

  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px -4px 8px rgb(0 0 0 / 20%);
  border-radius: 8px 8px 0px 0px;
  justify-content: space-evenly;
  align-items: center;
  padding: 10px 10px;

  .MuiButton-contained {
    border-radius: 2em;
    margin-top: 0;
    font-weight: bold;
    text-transform: capitalize;
    margin: 0px 2.5px;
  }

  /* On mobile, the global MobileBottomNav sits at bottom:0 / z-index:100.
     Without these offsets the cart action bar disappears underneath it.
     Lift the bar above the nav and stretch it to full viewport width so
     it reads as a sticky checkout bar, not a floating widget. */
  ${breakpoint.down('tablet')} {
    width: 100%;
    right: 0;
    bottom: calc(${mobile.bottomNavHeight} + ${mobile.safeAreaBottom});
    border-radius: 0;
    padding: 12px 16px;
    background: rgba(255, 255, 255, 0.98);
  }
`

export const ScrollContainer = styled.div`
  overflow-y: auto;
`

export const CartContentContainer = styled.div`
  flex: 1;
  padding: 16px;
  padding-top: 0px;
  padding-bottom: 0;
`
export const EmptyCartContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const EmptyCartSubcontainer = styled.div``

export const CartImageContainer = styled.div`
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const CartImage = styled.img`
  width: 100px;
`

export const EmptyCartHeading = styled.div`
  font-family: AvenirDemi;
  text-align: center;
`

export const EmptyCartSubheading = styled.div``

export const CartContainer = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
  overflow: hidden;
`

export const CartContentWrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
`
